import { useContext, useEffect } from "react"
import { useLocation } from "react-router-dom"
import { isChurchCenterApp } from "source/Layout"
import { WebBootContext } from "source/publishing/WebBoot"
import { useSession } from "source/shared/hooks/useSession"

declare global {
  interface Window {
    ccaVersion: string
  }
}

const CHURCH_CENTER_DOMAINS = [
  "churchcenter.test",
  "churchcenter.com",
  "churchcenter.dev",
  "churchcenter.ninja",
]
const EXCLUDED_PATH_PREFIXES = [
  "/unproxy",
  "/giving",
  "/people",
  "/pages/home",
  "/registrations/events",
]

export function useChurchCenterPageAnalytics() {
  const { pathname } = useLocation()
  const { abilities, analyticsUrl: analyticsBaseUrl } =
    useContext(WebBootContext)
  const {
    data: currentPerson,
    meta: { authenticated },
  } = useSession(false)
  const track_analytics = abilities.publishing?.track_analytics || "none"
  const currentPersonId = currentPerson.id

  useEffect(() => {
    if (!analyticsBaseUrl || track_analytics === "none") return

    const isExcludedPath = EXCLUDED_PATH_PREFIXES.some((prefix) =>
      pathname.startsWith(prefix),
    )
    if (isExcludedPath) return

    const isAppWithTracking = window.ccaVersion

    if (isChurchCenterApp() && isAppWithTracking) return

    const analyticsUrl = new URL(analyticsBaseUrl)
    analyticsUrl.searchParams.append("h", window.location.hostname)
    analyticsUrl.searchParams.append("p", pathname)
    analyticsUrl.searchParams.append("s", isChurchCenterApp() ? "app" : "web")

    if (document.referrer && !isChurchCenterUrl(document.referrer)) {
      analyticsUrl.searchParams.append("r", document.referrer)
    }

    if (authenticated) {
      analyticsUrl.searchParams.append("v", `acid-${currentPersonId}`)
    }

    if (track_analytics === "all" || pathname === "/home") {
      const xhr = new XMLHttpRequest()
      xhr.open("POST", analyticsUrl.toString())
      xhr.send()
    }
  }, [
    analyticsBaseUrl,
    currentPersonId,
    pathname,
    track_analytics,
    authenticated,
  ])

  return null
}

function isChurchCenterUrl(potentialChurchCenterUrl: string) {
  const url = new URL(potentialChurchCenterUrl)
  const host = url.hostname.split(".")
  const domain = host.length > 1 ? host.slice(-2).join(".") : host[0]

  return CHURCH_CENTER_DOMAINS.includes(domain)
}
